"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var core_1 = require("@material-ui/core");
var icons_1 = require("@material-ui/icons");
var react_intl_1 = require("react-intl");
var groupBy_1 = require("./utils/groupBy");
var Checkbox_1 = require("./components/Checkbox");
var TTableColumnsVisibilityFilter_1 = __importDefault(require("./TTableColumnsVisibilityFilter"));
var useStyles = core_1.makeStyles({
    nowrap: {
        whiteSpace: 'nowrap',
    },
    topScrollPaper: {
        alignItems: 'flex-start',
    },
    topPaperScrollBody: {
        verticalAlign: 'top',
    },
    gridItem: {
        maxWidth: '100%',
    },
});
var COMMON_GROUP_CODE = 'common';
function TTableColumnsVisibility(props) {
    var columns = props.columns, visibleColumns = props.visibleColumns, triggerLoadData = props.triggerLoadData, changeVisibleColumns = props.changeVisibleColumns;
    var classes = useStyles();
    var intl = react_intl_1.useIntl();
    var _a = react_1.useState(false), isWasChanged = _a[0], setIsWasChanged = _a[1];
    var commonGroupTitle = intl.formatMessage({ id: 'ttable.commonColumns', defaultMessage: 'Основные столбцы' });
    var _b = react_1.useState([]), filteredColumnCodes = _b[0], setFilteredColumnCodes = _b[1];
    var filteredColumns = react_1.useMemo(function () { return columns.filter(function (c) { return filteredColumnCodes.includes(c.columnCode); }); }, [
        columns,
        filteredColumnCodes,
    ]);
    var visibleColumnsId = react_1.useMemo(function () { return visibleColumns.map(function (_) { return _.columnCode; }); }, [visibleColumns]);
    var commonCols = react_1.useMemo(function () { return filteredColumns.filter(function (_) { return !_.groupCode; }); }, [filteredColumns]);
    var colsWithGroup = react_1.useMemo(function () { return filteredColumns.filter(function (_) { return !!_.groupCode; }); }, [filteredColumns]);
    var groupedCols = react_1.useMemo(function () { return groupBy_1.groupBy(colsWithGroup, function (col) { return col.groupCode; }); }, [colsWithGroup]);
    var groupedColsForView = react_1.useMemo(function () {
        var groups = Array.from(groupedCols.keys()).map(function (code) {
            var cols = groupedCols.get(code) || [];
            var title = (cols.length > 0 && cols[0].groupTitle) || '';
            return {
                code: code,
                title: title,
                cols: cols,
            };
        });
        groups.unshift({
            code: COMMON_GROUP_CODE,
            cols: commonCols,
            title: commonGroupTitle,
        });
        return groups;
    }, [groupedCols, commonCols]);
    var handleChangeVisibility = react_1.useCallback(function (columnCode) {
        setIsWasChanged(true);
        changeVisibleColumns(columnCode);
    }, [changeVisibleColumns]);
    var renderColsGroup = react_1.useCallback(function (cols, groupTitle, groupCode) {
        if (!cols.length) {
            return null;
        }
        return (react_1.default.createElement(core_1.Box, { mb: 4, key: groupCode },
            react_1.default.createElement(core_1.Typography, { variant: "h6" }, groupTitle),
            react_1.default.createElement(core_1.Grid, { container: true, spacing: 2 }, cols.map(function (col) {
                var isVisible = visibleColumnsId.indexOf(col.columnCode) !== -1;
                return (react_1.default.createElement(core_1.Grid, { item: true, key: col.columnCode + col.rerenderKey, className: classes.gridItem },
                    react_1.default.createElement(Checkbox_1.Checkbox, { column: col, handleChangeVisibility: handleChangeVisibility, isVisible: isVisible })));
            }))));
    }, [handleChangeVisibility, visibleColumnsId]);
    var _c = react_1.default.useState(false), open = _c[0], setOpen = _c[1];
    var handleClickOpen = react_1.useCallback(function () {
        setOpen(true);
        setIsWasChanged(false);
    }, [setOpen, setIsWasChanged]);
    var handleClose = react_1.useCallback(function () {
        setOpen(false);
        if (isWasChanged) {
            triggerLoadData();
        }
    }, [setOpen, isWasChanged, triggerLoadData]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(core_1.Link, { onClick: handleClickOpen },
            react_1.default.createElement(react_intl_1.FormattedMessage, { id: "ttable.hideOpenColumns", defaultMessage: "\u0421\u043A\u0440\u044B\u0442\u044C/  \u043E\u0442\u043E\u0431\u0440\u0430\u0437\u0438\u0442\u044C \u0441\u0442\u043E\u043B\u0431\u0446\u044B" }, function (message) { return react_1.default.createElement("span", { className: classes.nowrap }, message); })),
        react_1.default.createElement(core_1.Dialog, { open: open, onClose: handleClose, maxWidth: "md", fullWidth: true, keepMounted: true, classes: {
                scrollPaper: classes.topScrollPaper,
                paperScrollBody: classes.topPaperScrollBody,
            } },
            react_1.default.createElement(core_1.DialogTitle, null,
                react_1.default.createElement(core_1.Grid, { container: true, direction: "row", justify: "space-between" },
                    react_1.default.createElement(core_1.Grid, { item: true },
                        react_1.default.createElement(react_intl_1.FormattedMessage, { id: "ttable.columnVisibility", defaultMessage: "\u0421\u043E\u0441\u0442\u0430\u0432 \u0442\u0430\u0431\u043B\u0438\u0446\u044B" })),
                    react_1.default.createElement(core_1.Grid, { item: true },
                        react_1.default.createElement(core_1.IconButton, { size: "small", onClick: handleClose },
                            react_1.default.createElement(icons_1.Clear, null))))),
            react_1.default.createElement(core_1.Divider, null),
            react_1.default.createElement(core_1.DialogContent, null,
                renderColsGroup(visibleColumns, intl.formatMessage({ id: 'ttable.visibleColumns', defaultMessage: 'Включенные столбцы' })),
                react_1.default.createElement(TTableColumnsVisibilityFilter_1.default, { columns: columns, commonGroupCode: COMMON_GROUP_CODE, commonGroupTitle: commonGroupTitle, setFilteredColumnCodes: setFilteredColumnCodes }),
                groupedColsForView.map(function (_a) {
                    var code = _a.code, title = _a.title, cols = _a.cols;
                    return renderColsGroup(cols, title, code);
                })))));
}
exports.default = TTableColumnsVisibility;
